module.exports = __webpack_public_path__ + "static/media/Krabby_gaussian2.dfb95b2b.png";